import { Spdr } from "../Spdr";
import { spdrDefaultValues } from "./spdrDefaultValues";
import { useAddSpdr } from "../Hooks/useAddSpdr";
import { SpdrFormWithTabs } from "./SpdrFormWithTabs";

export const AddSpdr = () => {
  const { mutate: addSpdr } = useAddSpdr();

  return (
    <SpdrFormWithTabs
      title="Add SPDR"
      spdr={spdrDefaultValues}
      onSave={(spdr: Spdr) => addSpdr(spdr)}
    />
  );
};
